/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_Documents_InvalidInputs */

const en_error_inbound_documents_invalid = /** @type {(inputs: Error_Inbound_Documents_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some files cannot be linked to the inbound.`)
};

/**
* | output |
* | --- |
* | "Some files cannot be linked to the inbound." |
*
* @param {Error_Inbound_Documents_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_documents_invalid = /** @type {((inputs?: Error_Inbound_Documents_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_Documents_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_documents_invalid(inputs)
});